import moment from 'moment'
import 'moment-timezone'
import numeral from 'numeral'
import auth from '@/auth'

const fieldCats = {
  'ALL': [
    { value: 'exchange_name', text: 'Exchange', format: 'string' },
    { value: 'exchange_id', text: 'Exchange ID', format: 'string' },
    { value: 'sampled', text: 'Sampled', format: 'boolean' },
    { value: 'pub_id', text: 'Publisher ID', format: 'String'},
    { value: 'pub_name', text: 'Publisher Name', format: 'String'},
    { value: 'med_id', text: 'Medium ID' },
    { value: 'zone_id', text: 'Zone ID', format: 'string' },

    { value: 'schain_length', text: 'Schain Length', format: 'number' },
    { value: 'schain_nodes', text: 'Schain Nodes', format: 'string' },

    { value: 'med_type', text: 'Medium Type' },
    { value: 'med_name', text: 'Medium Name', format: 'string' },
    { value: 'med_domain', text: 'Medium Domain', format: 'string' },

    { value: 'app_content_genre', text: 'App Content Genre', format: 'string' },
    { value: 'app_content_live', text: 'App Content Live', format: 'number' },
    { value: 'app_content_title', text: 'App Content Title', format: 'string' },

    { value: 'dev_os', text: 'Operating System' },
    { value: 'dev_os_ver', text: 'Operating System Version' },
    { value: 'dev_make', text: 'Device Make' },
    { value: 'dev_model', text: 'Device Model' },
    { value: 'dev_type', text: 'Device Type' },
    { value: 'dev_carrier', text: 'Device Carrier' },
    { value: 'dev_conn_type', text: 'Device Connection Type' },
    { value: 'dev_browser', text: 'Browser' },
    { value: 'dev_ip', text: 'IP Address' },
    { value: 'dev_id', text: 'Device ID' },

    { value: 'geo_country', text: 'Country' },
    { value: 'geo_metro', text: 'Metro Code' },
    { value: 'geo_region', text: 'Region' },
    { value: 'geo_city', text: 'City' },
    { value: 'geo_zip', text: 'Zip Code' },
    { value: 'geo_source', text: 'Location Info Source' },
    { value: 'geo_lat', text: 'Latitude', format: 'number' },
    { value: 'geo_lon', text: 'Longitude', format: 'number' },

    { value: 'ad_formats', text: 'Ad Formats' }, //list
    { value: 'page_pos', text: 'Position on page' },

    { value: 'dims', text: 'Placement Dimensions' }, //list
    { value: 'apis', text: 'Supported APIs' }, // list

    { value: 'video_duration', text: 'Video Duration' },
    { value: 'video_protocols', text: 'Video Protocols' },
    { value: 'video_linear', text: 'Video Linear', format: 'boolean' },

    { value: 'deal_ids', text: 'Deal IDs' }, //list

    { value: 'auction_type', text: 'Auction Type' },

    { value: 'session_depth', text: 'Session Depth' },

    { value: 'datacenter', text: 'Datacenter' },

    { value: 'app_bundle', text: 'App Bundle' },
    { value: 'instl', text: 'Interstitial', format: 'boolean' },

    { value: 'bid_dims', text: 'Bid Ad Dimension' },
    { value: 'bid_format', text: 'Bid Ad Format' },
    { value: 'bid_adm', text: 'Bid Adomain' },

    { value: 'bid_reject_reason', text: 'Bid Rejection Reason' },

    { value: 'avg_bid_cpm', text: 'Bid CPM', format: 'number' },
    { value: 'spend', text: 'Revenue', format: 'number' },
    { value: 'cost', text: 'Cost', format: 'number' },

    { value: 'clears', text: 'Cleared Auctions', format: 'number' },

    { value: 'bid_cid', text: 'Campaign ID' },
    { value: 'bid_crid', text: 'Creative ID' },
    { value: 'bid_seat', text: 'Seat' },

    { value: 'bid_deal_id', text: 'Deal ID', format: 'string' },

    { value: 'latency', text: 'Response Latency', format: 'number' },
    { value: 'bid_time', text: 'Bid Time', format: 'number' },
    { value: 'buyer_user_matched', text: 'Buyer User Matched', format: 'boolean' }
  ],
  'ADMIN_ONLY': [
    { value: 'auction_reject_reason', text: 'Auction Reject Reason' },
    {value: 'endpoint', text: 'Endpoint'}
  ],
  'PUBLISHER_ONLY': [],
  'DEMAND_ONLY': [{value: 'endpoint', text: 'Endpoint'}],
  'NO_PUBLISHER': [
  ],
  'NO_DEMAND': [
    { value: 'bidder_name', text: 'Demand Partner', format: 'string' },
    { value: 'bidder_id', text: 'Demand Partner ID', format: 'string' },
  ]
}

function getAllFields (listOptions) {
  let type = 'ADMIN'
  console.log("DBG setting reportUTils type to admin for now for all fields")

  switch (type) {
    case 'PUBLISHER':
      return fieldCats.ALL.concat(fieldCats.PUBLISHER_ONLY).concat(fieldCats.NO_DEMAND)
    case 'DEMAND':
      return fieldCats.NO_PUBLISHER.concat(fieldCats.DEMAND_ONLY).concat(fieldCats.ALL)
    case 'ADMIN':
      let fields = fieldCats.NO_PUBLISHER.concat(fieldCats.ADMIN_ONLY).concat(fieldCats.NO_DEMAND).concat(fieldCats.ALL)
      return fields
    default:
      console.log('unsupported user type')
  }
}

function getFieldOptions (listOptions) {
  let options = {}
  for (let field of getAllFields(listOptions)) {
    options[field.value] = field.text
  }
  return options
}

function getPrettyFieldName(field) {
  let fields = getAllFields()
  let f = field.toLowerCase()
  if(field === 'date') {
    return 'Date'
  }

  let label = fields.find(fieldItem => fieldItem.value === field ).text
  if(label) {
    return label
  }

  let stats = Object.assign({}, protectedStatOptions, globalStatOptions)
  let stat = stats[field]
  if(stat) {
    return stat.default
  }

  console.log('Couldnt find label for field/stat ' + field)
  return ''
}

//convert an already-existing array to have good strings for humans to read
function getPrettyFieldsList (list) {
  let newList = [];
  for(let item of list) {
    newList.push(getPrettyFieldName(item))
  }
  return newList
}

/* global request fields that anyone can report on,
such as auctions */
const globalStatOptions = {
  'auctions': { default: 'Auctions' },
  'bid_floor': { default: 'Bid Floor' },
  'uniques': { default: 'Unique Users' },
}

/* fields particular to the active user which
we dont want to let others report on. e.g. spend */
const protectedStatOptions = {
  'bids': { default: 'Bids' },
  'clears': { default: 'Clears' },
  'timeouts': { default: 'Timeouts' },
  'avg_latency': { default: 'Response Latency' },
  'cost': { default: 'Cost', DEMAND: null, PUBLISHER: 'Spend', EXCHANGE: 'Spend' },
  'avg_cost_cpm': { default: 'Cost CPM', DEMAND: null, PUBLISHER: 'Spend CPM', EXCHANGE: 'Spend CPM' },
  'spend': { default: 'Spend', DEMAND: 'Spend', PUBLISHER: null, EXCHANGE: null },
  'avg_spend_cpm': { default: 'Spend CPM', DEMAND: 'CPM', PUBLISHER: null, EXCHANGE: null },
  'clear_rate': { default: 'Clear Rate' },
  'avg_ivt_rate': { default: 'Ivt Rate' },
  'avg_bid': { default: 'Bid CPM', PUBLISHER: null, EXCHANGE: null },
  'bid_rate': { default: 'Bid Rate' },
  'fill_rate': { default: 'Fill Rate' },
  'profit': { default: 'Profit', PUBLISHER: null, EXCHANGE: null, DEMAND: null },
  'timeout_rate': { default: 'Timeout Rate' },
  'bid_reject_rate': { default: 'Bid Reject Rate' },
  'bid_rejections': { default: 'Bids Rejected' },
  'supply_user_match_rate': { default: 'Supply User Match Percent' },
  'partner_user_match_rate': { default: 'Bidder User Match Percent' },
  'unique_crids': { default: 'Unique CRIDs' }
}

function getStatOptions(mode = 'default', myAuctionsOnly = true) {
  let m = mode.toUpperCase()
  let opts = Object.assign({}, globalStatOptions)
  if(myAuctionsOnly) {
    opts = Object.assign(opts, protectedStatOptions)
  }

  let s = {}
  for(let statName in opts) {
    let stat = opts[statName]
    let val = stat[m] !== undefined ? stat[m] : stat.default
    if(val !== undefined && val !== null) {
      s[statName] = val
    }
  }

  return s
}

function getPrettyStatName(stat) {
  return getStatOptions()[stat]
}

function formatStat(statName, statNum) {
  switch (statName) {
    //whole numers
    case 'auctions':
    case 'bids':
    case 'clears':
    case 'timeouts':
    case 'responses':
    case 'impressions':
    case 'unique_users':
    case 'view_measures':
    case 'views':
    case 'responses_rejected':
      return numeral(Number(statNum).toPrecision(3)).format('0[.][00]a')
    //percentages
    case 'view_measure_rate':
    case 'view_rate':
    case 'clear_rate':
    case 'bid_rate':
    case 'timeout_rate':
    case 'response_reject_rate':
    case 'view_rate':
    case 'fill_rate':
    case 'avg_ivt_rate':
      return numeral(statNum/100).format('0.00%')
    //cents
    case 'bid_price':
    case 'bid_floor':
    case 'cost':
    case 'avg_cost_cpm':
    case 'avg_spend_cpm':
    case 'avg_bid':
    case 'spend':
    case 'profit':
    case 'avg_user_value':
      return numeral(statNum).format('$0,0[.]00')
    //small whole numbers
    case 'latency':
      return numeral(statNum).format('0[.][00]')
    //times (in seconds)
    case 'view_time_user_avg':
    case 'view_time_avg':
      return numeral(statNum).format('0,0') + 's'
    default:
      return statNum
  }
}

const intervalOptions = {
  'SECOND': 'Second',
  'MINUTE': 'Minute',
  'HOUR': 'Hour',
  'DAY': 'Day',
  'MONTH': 'Month',
  'YEAR': 'Year',
}

const operatorOptions = {
  'EQUAL': 'equal to',
  'LESS_THAN': 'less than',
  'GREATER_THAN': 'greater than',
  'NOT_EQUAL': 'not equal to',
  'CONTAINS': 'contains'
}

const conciseOperatorOptions = {
  'LESS_THAN': '<',
  'GREATER_THAN': '>',
  'EQUAL': '=',
  'NOT_EQUAL': '!=',
  'CONTAINS': 'contains'
}

//sometimes field is passed as a string, but we need field object data
//so here, we take what might be a string or an object, and get the field
//object for it
function getFieldObject(field) {
  if(typeof field === 'object') {
    return field
  } else if (typeof field === 'string') {
    return getAllFields().find(field2 => field2.value === field)
  } else {
    console.log('big problem')
  }
}

function getFormatOrNull(field) {
  field = getFieldObject(field)
  if(field !== null && typeof field === 'object' && 'format' in field){
    return field.format
  } else {
    return null
  }
}

function getFieldFormat(fieldName) {
  return getFormatOrNull(fieldName)
}

function getOperatorOptions(field) {
  switch(getFormatOrNull(field)) {
    //manyOptionString means we are going to request a report
    //once the user starts typing out a string, then search through
    //it so we can give them suggestions
    case 'string':
      return {
        'EQUAL': 'equal to',
        'CONTAINS': 'contains',
        'NOT_EQUAL': 'not equal to'
      }
    case 'number':
      return {
        'EQUAL': 'equal to',
        'LESS_THAN': 'less than',
        'GREATER_THAN': 'greater than',
        'NOT_EQUAL': 'not equal to'
      }
    case 'boolean':
      return {
        'EQUAL': 'equal to',
        'NOT_EQUAL': 'not equal to'
      }
    default:
      return {
        'EQUAL': 'equal to',
        'NOT_EQUAL': 'not equal to'
      }
  }
}

function getProcessedValue(value, field) {
  switch(getFormatOrNull(field)) {
    case 'number':
      //convert filter value to number
      return Number(value)
    case 'boolean':
      //convert filter to boolean
      return Boolean(value)
    default:
      return value
  }
}

function getReportOptions (mode, myAuctionsOnly) {
  console.log('getReportOptions !!!')
  return {
    statOptions: getStatOptions(mode, myAuctionsOnly),
    fieldOptions: getFieldOptions(mode, myAuctionsOnly),
    intervalOptions
  }
}

function getValueOrUndefined(value) {
  return (value ? value : 0)
}

//basically, just concats field names together with ', '
//for use in making bar graph entries
function getEntryName(row, fields) {
  let name = getValueOrUndefined(row[fields[0]])
  for (let x = 1; x < fields.length; x++) {
    name += ', ' + getValueOrUndefined(row[fields[x]])
  }
  return name
}

function getTimeZoneOffsetMillis(millis, timezone) {
  return moment.tz(millis, timezone).utcOffset() * 60 * 1000
}

const timezoneList = [
  'UTC',
  'US/Eastern',
  'US/Central',
  'US/Mountain',
  'US/Pacific',
  { text: '--------', disabled: true },
].concat(moment.tz.names().filter( name => name.includes('/') ))

const graphColors = [
  '#AA5FFB',
  '#50E3C2',
  '#3FCCF9',
  '#F86D6D',
  '#FFD12C',
  '#F8AA6D',
  '#EFA3FF',
  '#C0F884',
  '#C9C9C9',
  '#577AD6',
  '#662CA6',
  '#26BB4D',
  '#37788C',
  '#BE4949',
  '#887D55',
  '#F16A00',
  '#D31E7E',
  '#0FAEAE',
  '#636262',
  '#7AABD7',
]

//function to add stats together, with a special case for stats that
//need to be *averaged*, not added

//maybe invalid for bid price, bid floor?
function getNewStatTotal(oldTotal, newValue, statName, oldNumValues) {
  //oldNumValues is the number of values we've iterated over already
  switch (statName) {
    case 'auctions':
    case 'bids':
    case 'clears':
    case 'timeouts':
    case 'cost':
    case 'spend':
    case 'impressions':
    case 'unique_users':
    case 'profit':
      //just add those bad boys
      return oldTotal + newValue
    case 'bid_price':
    case 'bid_floor':
    case 'clear_rate':
    case 'bid_rate':
    case 'timeout_rate':
    case 'latency':
    case 'avg_cost_cpm':
    case 'avg_spend_cpm':
    case 'fill_rate':
      //return average of values
      //probably gonna be pretty inaccurate, try not to use
      return oldTotal + ((newValue - oldTotal) / (oldNumValues + 1))
  }
}

/*
 * given a report, add up all the stats and return and object containing the totals
 * will total intelligently, ie won't just sum percentages
 *
 * NOTATE BENE: won't necessarily work with non-time based reports,
 * since each stat will need to be weighted differently then.
 * Also with non-time based reports, the last ie hour may be weighted slightly
 * more than the rest of the time, in terms of percentage-based stats
 */
function totalStats (report, stats) {
  let totals = {}
  for(let stat of stats) {
    totals[stat] = 0
    for(let x = 0; x < report.length; x++) {
      let val = report[x][stat]
      if (!val) {
        continue
      }
      totals[stat] = getNewStatTotal(totals[stat], Number(val), stat, x)
    }
  }

  if (totals['clear_rate'] !== undefined)
    totals['clear_rate'] = (totals['clears'] / totals['bids'] * 100)

  return totals
}

function getFormattedDate(utcDate, interval = 'DAY', timezone = 'UTC') {
  console.log(utcDate)
  let date = Number(utcDate)
  // let offset = getTimeZoneOffsetMillis(datenum, timezone)
  // let date = utcDate // = datenum + offset
  switch (interval) {
    case 'YEAR':
      return moment(date).tz(timezone).format('YYYY')
    case 'MONTH':
      return moment(date).tz(timezone).format('MMMM YYYY')
    case 'DAY':
      return moment(date).tz(timezone).format('MMMM Do YYYY')
    case 'HOUR':
      if(timezone !== 'UTC') {
        return moment(date).tz(timezone).format('MMMM Do YYYY, h a')
      } else {
        return moment(date).tz(timezone).format('MMMM Do YYYY HH')
      }
    case 'MINUTE':
      if(timezone !== 'UTC') {
        return moment(date).tz(timezone).format('MMMM Do YYYY, h:mm a')
      } else {
        return moment(date).tz(timezone).format('MMMM Do YYYY, HH:mm')
      }

    case 'SECOND':
      if(timezone !== 'UTC') {
        return moment(date).tz(timezone).format('MMMM Do YYYY, h:mm:ss a')
      } else {
        return moment(date).tz(timezone).format('MMMM Do YYYY, HH:mm:ss')
      }

  }
}

function getUserFilter(context) {
  if (context === 'publisher') {
    return [{ field: 'pub_id', operator: 'EQUAL', value: auth.details().company_id }]
  }
  if (context === 'demand') {
    return [{ field: 'bidder_id', operator: 'EQUAL', value: auth.details().company_id }]
  }
  if (context === 'exchange') {
    return [{ field: 'exchange_id', operator: 'EQUAL', value: auth.details().company_id }]
  }
  return []
}

function getReportCSV (mode, report, fields, stats, interval, timezone) {
  let csvContent = "data:text/csv;charset=utf-8,";
  //make header
  let rowList = []
  for (let field of fields) {
    rowList.push(getPrettyFieldName(field))
  }
  for (let stat of stats) {
    rowList.push(getPrettyStatName(stat))
  }
  csvContent += rowList.join(',')
  csvContent += "\r\n"
  //make body
  for (let row of report) {
    rowList = []
    for (let field of fields) {
      let fv = row[field]
      if(field === 'date' && !isNaN(fv)) {
        fv = getFormattedDate(fv, interval, timezone)
      }

      rowList.push('"' + fv + '"')
    }
    for (let stat of stats) {
      let val = row[stat]
      rowList.push('"' + val + '"')
    }
    let rowString = rowList.join(',')
    csvContent += rowString + "\r\n"
  }
  return csvContent
}

function getSuggestedInterval (startMillis, endMillis) {
  let seconds = (endMillis - startMillis) / 1000

  let minPoints = 10 //max number of points we want to see on the x-axis
  if (seconds >= minPoints * 60 * 60 * 24 * 12) {
    return 'YEAR'
  } else if (seconds >= minPoints * 60 * 60 * 24 * 30) {
    return 'MONTH'
  } else if (seconds >= minPoints * 60 * 60 * 24) {
    return 'DAY'
  } else if (seconds >= minPoints * 60 * 60) {
    return 'HOUR'
  } else if (seconds >= minPoints * 60) {
    return 'MINUTE'
  } else {
    return 'SECOND'
  }
}

function isExchangeView (vm) {
  return ('exchangeView' in vm.$route.query && vm.$route.query.exchangeView)
}

function getBasePublisherField (context) {
  if (context === 'publisher') {
    return 'med_name'
  } else if (context === 'exchange') {
    return 'bidder_name'
  } else {
    return 'exchange_name'
  }
}

//returns price for admin and demand, and cost for publisher
function getDefaultPriceField () {
  console.log('todo determine def price field')
  return 'spend' // or cost
}

//returns price for admin and demand, and cost for publisher
function getDefaultAveragePriceField () {
  console.log('todo def avg price field')
  return 'avg_spend_cpm'
}

export {
  getFieldOptions,
  getAllFields,
  getFieldFormat,
  getPrettyFieldsList,
  intervalOptions,
  operatorOptions,
  conciseOperatorOptions,
  getOperatorOptions,
  getProcessedValue,
  getReportOptions,
  getEntryName,
  getTimeZoneOffsetMillis,
  formatStat,
  timezoneList,
  graphColors,
  totalStats,
  getFormattedDate,
  getPrettyStatName,
  getStatOptions,
  getUserFilter,
  getReportCSV,
  getSuggestedInterval,
  isExchangeView,
  getBasePublisherField,
  getDefaultPriceField,
  getDefaultAveragePriceField
}



// WEBPACK FOOTER //
// ./src/reports/components/ReportUtils.js